import React from 'react'
import styled from 'styled-components'

const Container = styled.p`
  font-size: 12px;
  line-height: 16px;

  > a {
    text-decoration: none;
  }
`

const MadeBy = () => (
  <Container>
    Design made with love by&nbsp;
    <a href="http://fabienlaborie.com/" target="_blank">
      www.fabienlaborie.com
    </a>
  </Container>
)

export default MadeBy



// WEBPACK FOOTER //
// ./src/components/MadeBy.js